import { Box } from '@mui/system'
import { groupBy } from 'lodash-es'
import PropTypes from 'prop-types'

import PartCategoryPanel from './PartCategoryPanel/PartCategoryPanel'

const PartsList = ({ nqp, onPartSelected, parts, selectedPart }) => {
    return parts ? (
        <Box>
            {Object.entries(groupBy(parts, 'category')).map(([category, parts]) => (
                <PartCategoryPanel
                    categoryName={category}
                    expanded={selectedPart ? selectedPart.category === category : false}
                    key={category}
                    nqp={nqp}
                    parts={parts}
                    selectedPart={selectedPart}
                    onPartSelected={onPartSelected}
                />
            ))}
        </Box>
    ) : null
}

PartsList.propTypes = {
    nqp: PropTypes.bool,
    parts: PropTypes.array,
    selectedPart: PropTypes.object,
    onPartSelected: PropTypes.func,
}

export default PartsList
